import { Component } from '@angular/core';
import { WsService } from '../../services/ws/ws.service';
import { environment } from '../../../environments/environment';
import { SelectedClubService } from '../../services/selected-club.service';
import { SessionService } from '../../services/session.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
     IAccessControlValidation,
     ILoginObRes,
     ILoginRes,
     ISession,
} from '../../../typings';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionPrepareService } from '../../services/session-prepare.service';
import { SpinnerMessageService } from '../../services/spinner-message.service';
import { ErrorDialogService } from '../../services/error-dialog.service';
import { BootstrapSessionService } from '../../services/bootstrap-session';

export interface IStation {
     ip: any;
     hostname: string;
     version: string;
     uiVersion: string;
     dbVersion: string;
}

@Component({
     selector: 'app-auth',
     templateUrl: './auth.component.html',
     styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
     club: any;
     defaultClub: any;
     stationInfoVisible = false;
     station: IStation;
     appCfg = { ...window.app };
     constructor(
          private ws: WsService,
          private selectedClub: SelectedClubService,
          private session: SessionService,
          private router: Router,
          private toastr: ToastrService,
          private loader: NgxSpinnerService,
          private sessionPrepare: SessionPrepareService,
          private spinnerMessage: SpinnerMessageService,
          private errorDialog: ErrorDialogService,
          private bootstrapSession: BootstrapSessionService
     ) {
          this.setDefaults();
          this.station = {
               hostname: window.app.station.hostname,
               ip: window.app.station.ip,
               uiVersion: window.VERSION,
               dbVersion: window.app.station.dbVersion,
               version: window.app.station.version,
          };
     }

     userId: string = environment.production ? '' : '2929'; // 2923

     setDefaults() {
          this.club = { ...this.selectedClub.club };
          this.defaultClub = { ...this.selectedClub.getDefault() };
     }

     pressKey(key: string) {
          if (/[\d]+/g.test(key)) {
               this.userId += key;
          } else if (key === 'backspace') {
               this.userId = this.userId.slice(0, this.userId.length - 1);
          } else if (key === 'check') {
               this.login().catch(() => {});
          } else if (key === 'clear') {
               this.userId = '';
          }
     }

     async login() {
          try {
               let res1: ILoginObRes, res2: ILoginRes, session: ISession;
               this.loader.show();
               let external = this.selectedClub.isExternal();
               if (external) {
                    res1 = (await this.ws.auth.loginExternal(
                         this.userId,
                         this.club.obId
                    )) as ILoginObRes;
               } else {
                    res2 = (await this.ws.auth.loginInternal(
                         this.userId
                    )) as ILoginRes;
               }
               session = await this.sessionPrepare.run(external, res1, res2);
               this.spinnerMessage.accessControlValidation();
               try {
                    let result =
                         (await this.ws.accessControl.validate()) as IAccessControlValidation;
                    if (result && result.authorized) {
                         this.bootstrapSession.run();
                         this.router.navigateByUrl('/app');
                         this.loader.hide();
                         this.spinnerMessage.reset();
                    } else {
                         this.errorDialog.openErrorDialog(
                              session,
                              'unauthorized'
                         );
                    }
               } catch (err) {
                    let timeout = err && err.ctxCode === 'TIMEOUT'; // Check if it was a timeout erro
                    this.errorDialog.openErrorDialog(
                         session,
                         timeout ? 'timeout' : 'unexpected'
                    );
               }
          } catch (err) {
               this.loader.hide();
               if (err && err.status === 404) {
                    this.toastr.error(
                         window.appLang.PLEASE_CHECK_YOUR_CREDENTIALS,
                         null,
                         {
                              positionClass: 'toast-top-center',
                         }
                    );
                    this.userId = '';
               } else {
                    this.toastr.error(window.appLang.GENERIC_ERROR_MSG);
               }
          }
     }

     resetSelection() {
          this.selectedClub.reset();
          this.club = { ...this.selectedClub.club };
     }

     undo() {
          this.userId = this.userId || '';
          const len = this.userId.length - 1;
          if (len <= 0) {
               this.userId = '';
               return void 0;
          }
          this.userId = this.userId.slice(0, len);
     }
}
